export const useIsOverflowingString = (string: string) => {
	const stringArr = string.split(' ')

	return stringArr.some((string) => string.length > 8)
}
